module.exports = __webpack_public_path__ + "static/img/ldt4.e939ab2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/ldt4.png
// module id = 8A44
// module chunks = 0